//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import AnoFiscalCard from './AnoFiscalCard';

export default {
  name: 'AnoFiscalPesquisar',
  components: {
    AnoFiscalCard,
  },
  props: {
    habilitarBloqueio: {
      type: Boolean,
      default: false,
    },
    habilitarFechamento: {
      type: Boolean,
      default: false,
    },
    habilitarPeriodosOrcamento: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      tipos: [],
      carregouTipos: false,
      resourcesOrcamentoTipoVerba: this.$api.orcamentoTipoVerba(this.$resource),
    };
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el === 'ANO_FISCAL').length;
    },
  },
  methods: {
    accessForbidden() {
      this.$router.push({ name: 'inicio' });
      this.$toast.create(this.$t('message.acesso_negado'), 'snack', 3E3);
    },
    pesquisarTipos() {
      this.resourcesOrcamentoTipoVerba.buscarAtivos()
        .then((res) => {
          this.tipos = res.data;
          this.carregouTipos = true;
        }, (err) => {
          this.$error(this, err);
        });
    },
  },
  mounted() {
    this.pesquisarTipos();
  },
  beforeMount() {
    if (!this.canAccessPage) {
      window.setTimeout(() => {
        this.accessForbidden();
      }, 1E3);
    }
  },
};



// WEBPACK FOOTER //
// ./src/spa/ano-fiscal/AnoFiscalPesquisar.vue?vue&type=script&lang=js&